export default __webpack_public_path__ + "static/media/icon_sucursales.48f7873e.svg";